exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".toggle-header{display:flex;flex-direction:row;align-items:center;background-color:#c7c7c7;color:#111;height:32px}.toggle-header .title{font-weight:bold;flex-grow:1;padding-left:8px}.toggle-header .btn{padding-left:8px;padding-right:8px}.toggle-header .btn:hover{background-color:#b1b1b1}", ""]);

